import React, { useState } from "react";
import axios from "axios";
import "./AadhaarInput.css";

const AadhaarInput = ({ onNext }) => {
  const [aadhaar, setAadhaar] = useState("");
  const [mobile, setMobile] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const isAadhaarValid = /^\d{12}$/.test(aadhaar);
  const isMobileValid = /^\d{10}$/.test(mobile);

  const isFormValid = isAadhaarValid && isMobileValid && consent;

  const sendOtp = async () => {
    if (!isFormValid) return;
    setLoading(true);

    try {
      const API_URL =
        "https://fundswalla.in/loan_backend/sendAadhaarOtp.php";

      const payload = {
        aadhaar_number: aadhaar,
        mobile_number: mobile,
      };

      const res = await axios.post(API_URL, payload, {
        headers: { "Content-Type": "application/json" },
      });

      const raw = res.data.raw || {};
      const { responseMessage, responseCode } = raw;

      if (
        responseMessage === "Aadhar does not exist" ||
        responseCode === "EAE168"
      ) {
        alert("Invalid Aadhaar number.");
        setLoading(false);
        return;
      }

      localStorage.setItem("aadhaarNumber", aadhaar);
      localStorage.setItem("mobileNumber", mobile);
      localStorage.setItem("aadhaarReferenceId", res.data.referenceId);

      onNext();
    } catch (err) {
      alert("OTP failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aadhaar-page-wrapper">
      <div className="aadhaar-card">
        <div className="aadhaar-icon">🔐</div>

        <h3 className="aadhaar-title">Secure Aadhaar Verification</h3>

        <p className="aadhaar-subtitle">
          Enter your Aadhaar and linked mobile number.
        </p>

        {/* Aadhaar Input */}
        <input
          maxLength={12}
          value={aadhaar}
          onChange={(e) =>
            /^\d*$/.test(e.target.value) && setAadhaar(e.target.value)
          }
          placeholder="XXXX XXXX XXXX"
          className={`aadhaar-input ${isAadhaarValid ? "valid" : ""}`}
        />

        {/* Mobile Number Input */}
        <input
          maxLength={10}
          value={mobile}
          onChange={(e) =>
            /^\d*$/.test(e.target.value ) && setMobile(e.target.value)
          }
          placeholder="Enter mobile number linked with Aadhaar"
          className={`aadhaar-input ${isMobileValid ? "valid" : ""}`}
        />

        <div className="form-check consent-box">
          <input
            type="checkbox"
            checked={consent}
            onChange={() => setConsent(!consent)}
          />
          <label>
            I authorize <b>Aadhaar verification</b> and receipt of{" "}
            <b>digital communications</b>.
          </label>
        </div>

        <button
          className={`aadhaar-btn ${isFormValid ? "active" : "disabled"}`}
          disabled={!isFormValid || loading}
          onClick={sendOtp}
        >
          {loading ? "Sending OTP..." : "Get OTP"}
        </button>

        <p className="aadhaar-note">
          Your information is encrypted and secured.
        </p>
      </div>
    </div>
  );
};

export default AadhaarInput;
